import { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';

import { PaymentInformation, PaymentInformationWithDetails } from '../../classess/paymentInformation/paymentInformation';
import { GlobalFormats } from '../../classess/main/globalFormats';
import parse from 'html-react-parser';
import PaymentInformationDetailAdd from './PaymentInformationDetailAddEdit';
import {
    awaitDelayAsync, getProcessButtons, checkFile, convertFileAsync, dataTableLanguaje, getDocumentMaxFilesMessage, getDtRowIndex, isUndNull, isUndNullEmp, getLanguageObj,
    getResponse, handleResponseMessageAsync, settings, styles, LoadingSection, getNoImage
} from '../../helpers/main';
import { PaymentInformationService } from '../../services/paymentInformation/PaymentInformationService';
import { PaymentInformationDetailService } from '../../services/paymentInformation/PaymentInformationDetailService';
import useAuth from '../../auth/UseAuth';
import Menu from '../main/Menu';
import { Company } from '../../classess/company/company';
import { PaymentInformationDetail } from '../../classess/paymentInformation/paymentInformationDetail';
import { useDropzone } from 'react-dropzone';
import Swal from 'sweetalert2';
import { CompanyService } from '../../services/companies/CompanyService';
import AccessDenied from '../main/AccessDenied';
import TableIndex from '../main/TableIndex';

const $ = window.jqGlobal || window.jQuery;

const { app, backend, html, colors, files, icons, images, labels, messages, timers } = settings;

const currentMethod = 'PaymentInformationEditDetails';

export default function PaymentInformationEditDetails({
    languageObj = GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
}) {
    //#region variables
    const { type, id, } = useParams();
    const auth = useAuth();
    const userRole = auth?.userRole({ languageId: languageObj?.id, subMethod: currentMethod })?.result || '';
    const isMount = useRef(false);
    // const inpLogoRef = useRef(null);
    const [companies, setCompanies] = useState([Company?.getClass({}, false)]);
    const [companiesAddEdit, setCompaniesAddEdit] = useState([Company?.getClass({}, false)]);
    const [process, setProcess] = useState({ showLoading: true, save: false, add: false, detail: false, back: false, });
    const [viewType] = useState(type === labels?.edit?.en?.toLowerCase() ? 1 : 2);
    const dtPaymentInformationDetailsId = 'dtPaymentInformationDetails';
    const [showData, setShowData] = useState(true);
    const [paymentInformation, setPaymentInformation] = useState(PaymentInformation?.class({}, false));
    const [paymentInformationDetail, setPaymentInformationDetail] = useState(PaymentInformationDetail?.class({}, false));
    const [errors, setErrors] = useState({ name: '' });
    const [modalObj, setModalObj] = useState({
        $: $,
        type: 0,
        auth: auth,
        userRole: userRole,
        showModal: false,
        languageObj: languageObj,
        companies: companies,
        setCompanies: setCompanies,
        dtPaymentInformationDetailsId: dtPaymentInformationDetailsId,
        dtPaymentInformationDetailsRowId: 0,
        paymentInformation: paymentInformation,
        setPaymentInformation: setPaymentInformation,
        paymentInformationDetail: paymentInformationDetail,
        setPaymentInformationDetail: setPaymentInformationDetail,
    });
    const dataFormLength = PaymentInformation.minMaxLength(false);
    const fileObjEmpty = { lastModified: 0, lastModifiedDate: {}, name: '', path: '', preview: '', size: 0, type: '', webkitRelativePath: '', };
    const [fileState, setFileState] = useState(fileObjEmpty);
    const fileTypes = files?.acceptedTypes?.images?.concat([]);
    const { getRootProps, getInputProps } = useDropzone({
        accept: settings.react.dropZone.imagesAccepted,
        onDrop: async (acceptedFiles) => {
            let response = getResponse({ type: 0 });
            const currentMethod = 'dropZone - onDrop';
            try {
                //#region check files
                if (!isUndNullEmp({ data: acceptedFiles, subMethod: currentMethod })?.result && acceptedFiles?.length > 0) {
                    if (acceptedFiles?.length <= files?.paymentInformation?.logo.quantity) {
                        //#region check file
                        const fileObj = acceptedFiles[0] || fileObjEmpty;
                        response = checkFile({
                            type: fileObj.type,
                            size: fileObj.size,
                            allowedTypes: fileTypes,
                            maxSize: files?.paymentInformation?.logo.maxSize,
                            languageId: languageObj?.id,
                            subMethod: currentMethod
                        });
                        if (!response?.isSuccess || response?.isWarning) return;
                        //#endregion check file

                        //#region create url preview
                        //fileObj = Object.assign(fileObj, { previw: URL.createObjectURL(fileObj) })
                        fileObj.preview = URL.createObjectURL(fileObj);
                        setFileState(fileObj);
                        //#endregion create url preview

                        //#region convert file (base64url)
                        response = await convertFileAsync.toBase64URL({ file: acceptedFiles[0], subMethod: currentMethod, });
                        if (!response?.isSuccess || response?.isWarning) return;

                        setPaymentInformation(prev => ({ ...prev, logo: response?.result, }));
                        //#endregion convert file (base64url)
                    } else {
                        response = getDocumentMaxFilesMessage({
                            maxFiles: files?.paymentInformation?.logo.quantity,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });
                        if (!response?.isSuccess || response?.isWarning) return;
                    }
                }
                //#endregion check files
            } catch (ex) {
                response = getResponse({ type: -1 });
                response.msgText = `Method: ${currentMethod}<br/>`;
                response.msgText += `Error: ${ex?.message}<br/>`;
            } finally {
                if (!isMount?.current) return;
                // CSN:
                if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                    await handleResponseMessageAsync({ response, currentMethod, auth, languageId: languageObj?.id });
                }
            }
        },
    });
    const controls = {
        buttons: {
            back: {
                id: 'btnBack',
                defaultClass: 'btn btn-outline-secondary shadow-sm font-weight-bold mx-1 px-4',
            },
            detailsAdd: {
                defaultClass: 'btn btn-info shadow-sm font-weight-bold mx-1 px-4',
                id: 'btnDetailsAdd',
            },
            edit: {
                defaultClass: 'btn btn-primary shadow-sm font-weight-bold mx-1 px-4',
                id: 'btnEdit',
            },
        },
        dataTables: {
            paymentInformationDetails: {
                inputs: {
                    search: {
                        id: `${dtPaymentInformationDetailsId}_filter input`,
                        defaultClass: '',
                    },
                },
                selects: {
                    entries: {
                        id: `${dtPaymentInformationDetailsId}_length select`,
                        defaultClass: '',
                    },
                },
                paginateds: {
                    paginated: {
                        id: `${dtPaymentInformationDetailsId}_paginate`,
                        defaultClass: '',
                    }
                }
            },
        },
        dropzone: {
            logo: {
                id: 'dzLogo',
            },
        },
        icons: {
            back: {
                id: 'iconBack',
                defaultClass: icons?.fasFa?.arrowCircleLeft,
            },
            detailsAdd: {
                id: 'iconDetailsAdd',
                defaultClass: icons?.listAlt,
            },
            edit: {
                id: 'iconEdit',
                defaultClass: icons?.fasFa?.save,
            },
        },
        inputs: {
            name: {
                id: 'inpName',
                defaultClass: '',
            },
        },
        spiners: {
            back: {
                id: 'spBack',
                defaultClass: '',
            },
            detailsAdd: {
                id: 'spDetailsAdd',
                defaultClass: '',
            },
            edit: {
                id: 'spEdit',
                defaultClass: '',
            }
        },
    };
    //#endregion variables

    //#region methods
    //#region paymentinformations
    const editPaymentInformation = async ({
        e = undefined,
        subMethod = '',
    } = {}) => {
        const currentMethod = 'editPaymentInformation';
        let response = getResponse({ type: 0 });
        try {
            e?.preventDefault?.();

            //#region errors default / validate data
            response = setErrorsDefault({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;

            response = validateFormData({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;
            //#endregion errors default / validate data

            setProcess(prev => ({ ...prev, showLoading: true, save: true }));

            //#region paymentinformation (update)
            response = await PaymentInformationService.update({
                token: auth?.user?.token?.token,
                data: paymentInformation,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) return;

            const paymentInformationData = PaymentInformationWithDetails.class(response?.result?.paymentInformation || {}, false);
            setPaymentInformation(paymentInformationData);
            const companiesData = response?.result?.companies || [];
            setCompanies(companiesData);
            //#endregion paymentinformation (update)

            //#region set data in datatables
            response = setDataInDataTable({
                data: paymentInformationData?.accounts || [],
                companies: companiesData,
                clear: true,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) return;
            //#endregion set data in datatables

            response.msgText = `${messages?.processCompletedSuccessfully?.[languageObj?.id]}.`;
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;
            setProcess(prev => ({ ...prev, showLoading: false, save: false }));
            // CSN:
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({ response, currentMethod, auth, languageId: languageObj?.id });
            }
        }
    }
    //#endregion paymentinformations

    //#region paymentinformation (detail)
    const getPaymentInformationDetailAdd = async ({
        e = {},
        subMethod = '',
    } = {}) => {
        const currentMethod = 'getPaymentInformationDetailAdd';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            let companiesData = [];
            //#endregion variables

            setProcess(prev => ({ ...prev, showLoading: true, add: true }));

            e?.preventDefault?.();

            //#region companies (getall)
            if (isUndNullEmp({ data: companiesAddEdit, subMethod: currentMethod, })?.result ||
                companies?.length < 0) {
                response = await CompanyService.getAll({
                    auth: auth,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });

                if (!response?.isSuccess || response?.isWarning) return;

                companiesData = response?.result?.companies || [];
                setCompaniesAddEdit(companiesData);
                setCompanies(companiesData);
            } else {
                await awaitDelayAsync({ delayTime: timers?.oneSecond, });
            }
            //#endregion companies (getall)

            //#region paymentInformationDetail (set)
            const paymentInformationDetailData = PaymentInformationDetail.class({
                paymentInformationId: paymentInformation?.id,
                register: new Date().toISOString(),
            }, false);
            //#endregion paymentInformationDetail (set)

            setModalObj({
                ...modalObj,
                companies: companiesData?.length > 0 ? companiesData : companiesAddEdit,
                paymentInformation: paymentInformation,
                paymentInformationDetail: paymentInformationDetailData,
                type: 0,
                showModal: true,
            });
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;
            setProcess(prev => ({ ...prev, showLoading: false, add: false }));
            // CSN:
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({ response, currentMethod, auth, setShowData, showDataValue: response?.isSuccess, languageId: languageObj?.id });
            }
        }
    }

    const getPaymentInformationDetailEdit = async ({
        e = {},
        id = '',
        description = '',
        rowId = '',
        subMethod = '',
    } = {}) => {
        const currentMethod = 'getPaymentInformationDetailEdit';
        let response = getResponse({ type: 0 });
        try {
            e?.preventDefault?.();

            setProcess(prev => ({ ...prev, showLoading: true, detail: true }));

            //#region paymentinformationdetail (getbyid)
            response = await PaymentInformationDetailService.getById({
                token: auth?.user?.token?.token,
                id: parseInt(id),
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) return;

            const companiesData = response?.result?.companies || [];
            const paymentInformationData = response?.result?.paymentInformation || {};
            const paymentInformationDetailData = response?.result?.paymentInformationDetail || {};

            setCompanies(companiesData);
            setPaymentInformation(paymentInformationData);
            setPaymentInformationDetail(paymentInformationDetailData);
            //#endregion paymentinformationdetail (getbyid)

            setModalObj({
                ...modalObj,
                companies: companiesData,
                paymentInformation: paymentInformationData,
                paymentInformationDetail: paymentInformationDetailData,
                dtPaymentInformationDetailsRowId: rowId,
                type: 1,
                showModal: true,
            });
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;
            setProcess(prev => ({ ...prev, showLoading: false, detail: false }));
            // CSN:
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({ response, currentMethod, auth, languageId: languageObj?.id });
            }
        }
    }

    const deletePaymentInformationDetail = async ({
        e = {},
        id = '',
        description = '',
        rowId = 0,
        subMethod = '',
    } = {}) => {
        const currentMethod = 'deletePaymentInformationDetail';
        let response = getResponse({ type: 0 });
        try {
            e?.preventDefault?.();

            //#region show message
            let msgTextObj = {
                one: `${messages?.areYouShureDeleteThis?.[languageObj?.id]}`,
                two: `${labels?.paymentInformationDetail[languageObj?.id]}: <b>${description}</b><br/>`,
                three: `${messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`,
            };
            const swalProperties = {
                icon: settings.react.sweetAlert2.messages.types.warning,
                title: msgTextObj?.one,
                html: `${msgTextObj?.two}${msgTextObj?.three}`,
                timer: null,
                confirmButtonColor: colors?.warningColorExp,
                confirmButtonText: labels?.yes?.[languageObj?.id],
                showCancelButton: !Swal.isLoading(),
                cancelButtonColor: colors?.successColorExp,
                cancelButtonText: labels?.no?.[languageObj?.id],
                showLoaderOnConfirm: true,
                didOpen: () => {
                    Swal.hideLoading();
                },
                allowOutsideClick: () => !Swal.isLoading(),
                customClass: {
                    confirmButton: html?.buttons?.primary,
                    cancelButton: html?.buttons?.secondary,
                },
                preConfirm: async () => {
                    let preConfirmResponse = getResponse({ type: 0, });
                    try {
                        Swal.getCancelButton().hidden = true;
                        Swal.update({
                            icon: settings?.react?.sweetAlert2?.messages?.types?.info,
                            title: `${messages?.processingPleaseWait?.[languageObj?.id]}...`,
                            html: `${msgTextObj?.two}`,
                            showConfirmButton: false,
                        });

                        //#region delete data (paymentInformationDetail)
                        preConfirmResponse = await PaymentInformationDetailService.deleteAsync({
                            token: auth?.user?.token?.token,
                            id: id,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });

                        if (!preConfirmResponse?.isSuccess || preConfirmResponse?.isWarning) return preConfirmResponse;
                        //#endregion delete data (paymentInformationDetail)

                        //#region delete datatable (paymentInformationDetail)
                        $(`#${dtPaymentInformationDetailsId}`)?.DataTable()?.row(rowId)?.remove()?.draw(true);

                        preConfirmResponse.msgText = messages?.processCompletedSuccessfully?.[languageObj?.id];
                        //#endregion delete datatable (paymentInformationDetail)
                    } catch (ex) {
                        //#region error
                        preConfirmResponse = getResponse({ type: -1, });
                        preConfirmResponse.msgText = `Method: ${currentMethod}<br/>`;
                        preConfirmResponse.msgText += `Sub method: preConfirm<br/>`;
                        preConfirmResponse.msgText += `Error: ${ex?.message}<br/>`;
                        //#endregion error
                    }
                    return preConfirmResponse;
                },
            };

            const swalresult = await Swal.fire({ ...swalProperties });
            if (swalresult?.isConfirmed && swalresult?.value) {
                response = swalresult?.value;
            } else if (swalresult?.isDismissed) {
                response = getResponse({ type: 0 });
            }
            //#endregion show message
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;
            // CSN:
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({ response, currentMethod, auth, languageId: languageObj?.id });
            }
        }
    }
    //#endregion paymentinformation (detail)

    //#region others
    const getData = async ({
        subMethod = ''
    } = {}) => {
        const currentMethod = 'getData';
        let response = getResponse({ type: 0 });
        try {
            //#region check type (url)
            if (type !== labels?.edit?.en?.toLowerCase() && type !== labels?.details.en.toLowerCase()) {
                window.location.href = `${backend?.urls?.notFound}`;
                return;
            }
            //#endregion check type (url)

            if (auth?.isLoged({ subMethod: currentMethod })?.result) {
                setProcess(prev => ({ ...prev, showLoading: true }));

                setCompanies([])
                setCompaniesAddEdit([]);

                //#region datatable (set)
                response = setDataTables({ subMethod: currentMethod });
                if (!response?.isSuccess || response?.isWarning) return;
                //#endregion datatable (set)

                //#region set query code
                response = setQueryCode({ subMethod: currentMethod });
                if (!response?.isSuccess || response?.isWarning) return;
                //#endregion set query code

                //#region check role
                if (viewType === 1 && userRole !== settings?.roles?.admin) {
                    response = getResponse({ type: 1 });
                    response.msgText = `${messages?.youDoNotHaveSufficientPrivilegesToRunThisProcess?.[languageObj?.id]}.`;
                    setShowData(false);
                    return;
                }
                //#endregion check role

                //#region get data (paymentinformations)
                response = await PaymentInformationService.getById({
                    token: auth?.user?.token?.token,
                    id: id,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });

                if (!response?.isSuccess || response?.isWarning) return;

                const paymentInformationData = response?.result?.paymentInformation || {};
                setPaymentInformation(paymentInformationData);
                const companiesData = response?.result?.companies || [];
                setCompanies(companiesData);

                setFileState(prev => ({
                    ...prev,
                    preview: PaymentInformation.logoFullPath({
                        logo: paymentInformationData?.logo || '',
                        subMethod: currentMethod,
                    })?.result,
                }));
                //#endregion get data (paymentinformations)

                //#region set datatable
                if (!isUndNullEmp({ data: paymentInformationData?.accounts, subMethod: currentMethod })?.result &&
                    paymentInformationData?.accounts?.length > 0) {
                    response = setDataInDataTable({
                        data: paymentInformationData?.accounts,
                        companies: companiesData,
                        subMethod: currentMethod,
                    });
                    if (!response?.isSuccess || response?.isWarning) return;
                }
                //#endregion set datatable
            } else {
                setShowData(false);
            }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;
            setProcess(prev => ({ ...prev, showLoading: false }));
            // CSN:
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({ response, currentMethod, auth, setShowData, showDataValue: response?.isSuccess, languageId: languageObj?.id });
            }
        }
    }

    const setDataTables = ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setDataTables';
        let response = getResponse({ type: 0 });
        try {
            $(`#${dtPaymentInformationDetailsId}`).DataTable({
                //buttons: ['copy', 'csv', 'excel', 'pdf', 'print', 'colvis',],
                columns: [
                    { title: labels?.company?.[languageObj?.id], width: '20%', },
                    { title: labels?.rif?.[languageObj?.id], width: '10%', },
                    { title: labels?.email?.[languageObj?.id], width: '20%', },
                    { title: labels?.description?.[languageObj?.id], width: '15%', },
                    { title: labels?.number?.[languageObj?.id], width: '15%', },
                    { title: labels?.type?.[languageObj?.id], width: '10%', },
                    { title: labels?.process[languageObj?.id], visible: viewType === 1, className: 'text-center', width: '5%', orderable: false, searchable: false, },
                ],
                data: [],
                destroy: true,
                language: dataTableLanguaje({ code: languageObj?.id, }),
                order: [[0, 'asc']],
                responsive: true,
                lengthChange: true,
                autoWidth: false,
            });
            //.buttons().container().appendTo(`#${dtPaymentInformationDetailsId}_wrapper .col-md-6:eq(0)`);
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setQueryCode = ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setQueryCode';
        let response = getResponse({ type: 0 });
        try {
            //#region process
            $(`#${dtPaymentInformationDetailsId} tbody`).on('click', 'tr', 'td', async function (e) {
                const rowId = getDtRowIndex({ dtId: dtPaymentInformationDetailsId, _this: this, subMethod: currentMethod })?.result;
                if (!isUndNull({ data: rowId, subMethod: currentMethod })?.result) {
                    const methodName = e?.target?.attributes?.method?.value || '';
                    const id_ = e?.target?.attributes?.id?.value || '';
                    const description = e?.target?.attributes?.description?.value || '';
                    switch (methodName) {
                        case 'edit':
                            getPaymentInformationDetailEdit({ e: e, id: id_, description: description, rowId: rowId, subMethod: currentMethod, });
                            break;
                        case 'details':
                            break;
                        case 'delete':
                            deletePaymentInformationDetail({ e: e, id: id_, description: description, rowId: rowId, subMethod: currentMethod, });
                            break;
                        default:
                            break;
                    }
                }
            });
            //#endregion process
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setDataInDataTable = ({
        data = [],
        companies = [],
        clear = false,
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setDataInDataTable';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            let paymentInformationDetailsDt = [];
            //#endregion variables

            //#region process
            const dtPaymentInformationDetails = $(`#${dtPaymentInformationDetailsId}`).DataTable();
            if (clear) {
                dtPaymentInformationDetails.rows().clear();
            }

            data.forEach((detail) => {
                const modelPaymentInformationDetail = PaymentInformationDetail?.class(detail, false);
                const company = Company?.getClass(companies.filter(({ id, }) => id === modelPaymentInformationDetail?.companyId)[0] || {}, false);

                paymentInformationDetailsDt.push([
                    company?.name || '',
                    company?.rif || '',
                    company?.email || '',
                    modelPaymentInformationDetail?.name || '',
                    modelPaymentInformationDetail?.accountNumber || '',
                    modelPaymentInformationDetail?.accountType || '',
                    getProcessButtons({
                        id: modelPaymentInformationDetail.id,
                        description: modelPaymentInformationDetail.name,
                        showDetails: false,
                        labelDetails: labels?.details?.[languageObj?.id],
                        enabledDetails: false,
                        showDelete: userRole === settings?.roles?.admin && viewType === 1,
                        labelDelete: labels?.delete?.[languageObj?.id],
                        enabledDelete: userRole === settings?.roles?.admin && viewType === 1,
                        showEdit: userRole === settings?.roles?.admin && viewType === 1,
                        labelEdit: labels?.edit?.[languageObj?.id],
                        enabledEdit: userRole === settings?.roles?.admin && viewType === 1,
                        processButtons: [],
                    })?.result,
                ]);
            });

            dtPaymentInformationDetails.rows.add(paymentInformationDetailsDt)?.draw(true);
            //#endregion process
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const goToBack = async ({
        e = undefined,
        subMethod = '',
    } = {}) => {
        const currentMethod = 'goToBack';
        let response = getResponse({ type: 0 });
        try {
            setProcess(prev => ({ ...prev, showLoading: true, back: true }));
            await awaitDelayAsync({ delayTime: timers?.oneSecond });
            window.location.href = `${backend?.urls?.paymentInformations}`;
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;
            setProcess(prev => ({ ...prev, showLoading: false, back: false }));
            // CSN:
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({ response, currentMethod, auth, languageId: languageObj?.id });
            }
        }
    }

    const validateFormData = ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'validateFormData';
        let response = getResponse({ type: 0 });
        try {
            if (isUndNullEmp({ data: paymentInformation, subMethod: currentMethod })?.result ||
                isUndNullEmp({ data: paymentInformation?.name, subMethod: currentMethod })?.result) {
                setErrors(prev => ({ ...prev, name: `${messages?.thisFieldRequired?.[languageObj?.id]}.` }));
                response.isWarning = true;
            }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setErrorsDefault = ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setErrorsDefault';
        let response = getResponse({ type: 0 });
        try {
            setErrors(prev => ({ ...prev, name: '' }));
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const showDropZone = async ({
        e = undefined,
        subMethod = ''
    } = {}) => {
        const currentMethod = 'showDropZone';
        let response = getResponse({ type: 0 });
        try {
            e?.preventDefault?.();
            if (!process?.save) {
                $(`#${controls?.dropzone?.logo?.id}`).trigger('click');
            }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;

            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({ response, currentMethod, auth, languageId: languageObj?.id });
            }
        }
    }

    useEffect(() => {
        isMount.current = true;
        getData({ subMethod: 'form - onLoad' });
        return () => {
            isMount.current = false;
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    //#endregion others
    //#endregion methods
    return (
        <div>
            <Menu viewName={app?.views?.paymentInformations?.paymentInformations} process={app?.views?.paymentInformations?.paymentInformations} />

            <div className='content-wrapper bg-transparent'>
                {/* Content Header (Page header) */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2 align-items-center bg-white p-3 rounded shadow-lg mx-0 border-bottom'
                            style={{ backdropFilter: 'blur(10px)', backgroundColor: 'rgba(255, 255, 255, 0.9)', borderRadius: '15px' }}>
                            <div className='col-12 col-sm-6 text-center text-sm-left'>
                                <h4 className='m-0 font-weight-bold text-dark letter-spacing-sm'>
                                    {viewType === 1 ? labels?.edit?.[languageObj?.id] : labels?.details?.[languageObj?.id]}
                                </h4>
                            </div>
                            <div className='col-12 col-sm-6 mt-2 mt-sm-0'>
                                <ol className='breadcrumb float-sm-right bg-transparent mb-0 p-0 justify-content-center justify-content-sm-end'>
                                    <li className='breadcrumb-item'><a href='/' className='text-muted'><i className={icons?.fasFa?.home} /> {labels?.home?.[languageObj?.id]}</a></li>
                                    <li className='breadcrumb-item'><a href={backend?.urls?.paymentInformations} className='text-muted'>{labels?.paymentInformations?.[languageObj?.id]}</a></li>
                                    <li className='breadcrumb-item active text-primary font-weight-bold'>
                                        {viewType === 1 ? labels?.edit?.[languageObj?.id] : labels?.details?.[languageObj?.id]}
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                {/* /.content-header */}

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>
                        {auth?.isLoged({ subMethod: currentMethod })?.result ? (
                            <div className='row'>
                                <div className='col-12'>
                                    {showData ? (
                                        <div className='card border-0 shadow-lg rounded-lg' style={{ borderRadius: '15px' }}>
                                            <LoadingSection alt='loadingSection'
                                                className='overlay dark text-white'
                                                height={30}
                                                hidden={!process?.showLoading}
                                                width={30}
                                                languageId={languageObj?.id}
                                                subMethod={currentMethod} />

                                            <div className='card-header bg-white border-bottom-0 pt-4 px-4'>
                                                <div className='d-flex align-items-center'>
                                                    <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                                                        style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                        <img alt={labels?.paymentInformation?.[languageObj?.id]} src={images?.icons?.paymentInformation} style={styles?.cardHeaderLogo} />
                                                    </div>
                                                    <div className='d-flex flex-column'>
                                                        <h5 className='mb-0 font-weight-bold text-dark'>{labels?.paymentInformation?.[languageObj?.id]}</h5>
                                                        <div className='mt-1'>
                                                            <span className={`badge badge-pill ${viewType === 1 ? html?.badges?.warning : html?.badges?.secondary} px-2 py-1 text-uppercase`} style={html?.badges?.micro}>
                                                                <i className={`${icons?.fasFa?.creditCard} mr-1`}></i> {viewType === 1 ? labels?.edit?.[languageObj?.id] : labels?.details?.[languageObj?.id]}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='card-body px-4 pb-4'>
                                                <form onSubmit={(e) => viewType === 1 ? editPaymentInformation({ e: e, subMethod: controls?.buttons?.edit?.id }) : e.preventDefault()}>
                                                    {viewType === 1 ? (
                                                        <div className='row align-items-center'>
                                                            <div className='col-12 col-md-8'>
                                                                <div className='form-group mb-4'>
                                                                    <small className={html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                                        <i className={icons?.fasFa?.creditCard} /> {labels?.name?.[languageObj?.id]}
                                                                    </small>
                                                                    <input id={controls?.inputs?.name?.id}
                                                                        autoFocus
                                                                        className={`form-control bg-light border-0 shadow-sm ${errors?.name !== '' ? 'is-invalid' : ''}`}
                                                                        style={{ borderRadius: '5px', height: '45px' }}
                                                                        maxLength={dataFormLength?.max?.name}
                                                                        disabled={process?.save}
                                                                        onChange={(e) => setPaymentInformation({ ...paymentInformation, name: e?.target?.value })}
                                                                        onFocus={() => setErrors(prev => ({ ...prev, name: '' }))}
                                                                        value={paymentInformation?.name || ''}
                                                                        placeholder={labels?.name?.[languageObj?.id]} />
                                                                    <div className='form-text text-danger small mt-1 animated fadeIn'>{parse(errors?.name)}</div>
                                                                </div>
                                                            </div>

                                                            <div className='col-12 col-md-4'>
                                                                <div className='form-group mb-4 text-center d-flex flex-column align-items-center'>
                                                                    {/* <small className={`${html?.labels?.detailMicro} w-100 text-md-left`}>
                                                                        <i className={icons?.fasFa?.camera} /> {labels?.logo?.[languageObj?.id]}
                                                                    </small> */}

                                                                    <div className='d-flex align-items-center w-100 mt-2'>
                                                                        <div className='mr-3' style={{ cursor: process?.save ? 'default' : 'pointer' }}>
                                                                            <a href='#logoPreview'
                                                                                className='d-block shadow-sm rounded bg-light border'
                                                                                style={{ width: '80px', height: '80px', padding: '10px', transition: 'all 0.3s ease', borderRadius: '5px' }}
                                                                                onClick={(e) => { showDropZone({ e: e, subMethod: 'logoPreview', }) }}>
                                                                                <img alt='logoPreview'
                                                                                    className='w-100 h-100'
                                                                                    style={{ objectFit: 'contain' }}
                                                                                    src={fileState?.preview || getNoImage({ processType: 1, subMethod: currentMethod, })?.result} />
                                                                            </a>
                                                                        </div>
                                                                        <div className='text-left'>
                                                                            <a href='#logoPreview'
                                                                                className='text-primary small font-weight-bold text-decoration-none'
                                                                                onClick={(e) => { showDropZone({ e: e, subMethod: 'logoPreviewText', }) }}>
                                                                                <small className='text-muted text-uppercase font-weight-bold d-block mb-3'>
                                                                                    <i className={icons?.fasFa?.camera} /> {messages?.clickToDefineTheLogo?.[modalObj?.languageObj?.id]}
                                                                                </small>
                                                                            </a>
                                                                        </div>
                                                                    </div>

                                                                    {!process?.showLoading ? (
                                                                        <div hidden {...getRootProps({ className: 'dropzone' })}>
                                                                            <input id={controls?.dropzone?.logo?.id} {...getInputProps()} />
                                                                        </div>
                                                                    ) : (
                                                                        <div></div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div className='row'>
                                                            {/* <div className='col-12 col-md-8 mb-4'>
                                                                <div className='p-3 rounded bg-light border-left border-primary shadow-sm h-100' style={{ borderLeftWidth: '5px' }}>
                                                                    <small className={html?.labels?.detailMicro}>
                                                                        <i className={`${icons?.fasFa?.creditCard} mr-1`} />
                                                                    </small> <span className='h5 mb-0 font-weight-bold text-dark'>{paymentInformation?.name || '---'}</span>
                                                                </div>
                                                            </div>

                                                            <div className='col-12 col-md-4 mb-4'>
                                                                <div className='p-3 rounded bg-light border-left border-info shadow-sm text-center h-100' style={{ borderLeftWidth: '5px' }}>
                                                                    <small className={html?.labels?.detailMicro}>
                                                                        <i className={`${icons?.fasFa?.camera} mr-1`} />
                                                                    </small>
                                                                    <div className='d-inline-block p-2 rounded bg-white shadow-sm border mt-1'>
                                                                        <img alt='logoDetail'
                                                                            style={{ width: '60px', height: '60px', objectFit: 'contain' }}
                                                                            src={fileState?.preview || getNoImage({ processType: 1, subMethod: currentMethod, })?.result} />
                                                                    </div>
                                                                </div>
                                                            </div> */}

                                                            <div className={`col-12 col-md-8 mb-3`}>
                                                                <div className={`p-3 rounded bg-light border-left border-primary shadow-sm h-100`}
                                                                    style={{ borderLeftWidth: '5px' }}>
                                                                    <small className='text-muted text-uppercase font-weight-bold d-block mb-1'
                                                                        style={html?.labels?.detailMicro}>
                                                                        <i className={`${icons?.fasFa?.creditCard} mr-1`} /> {labels?.name?.[languageObj?.id]}
                                                                    </small>
                                                                    <span className='text-dark font-weight-bold'>{paymentInformation?.name || '---'}</span>
                                                                </div>
                                                            </div>
                                                            <div className={`col-12 col-md-4 mb-3`}>
                                                                <div className={`p-3 rounded bg-light border-left border-info text-center shadow-sm h-100`}
                                                                    style={{ borderLeftWidth: '5px' }}>
                                                                    <small className='text-muted text-uppercase font-weight-bold d-block mb-1'
                                                                        style={html?.labels?.detailMicro}>
                                                                        <i className={`${icons?.fasFa?.camera} mr-1`} /> {labels?.logo?.[languageObj?.id]}
                                                                    </small>
                                                                    <div className='d-inline-block p-2 rounded bg-white shadow-sm border mt-1'>
                                                                        <img alt='logoDetail'
                                                                            style={{ width: '60px', height: '60px', objectFit: 'contain' }}
                                                                            src={fileState?.preview || getNoImage({ processType: 1, subMethod: currentMethod, })?.result} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}

                                                    <div className='d-flex flex-wrap justify-content-end align-items-center mt-3 mb-2' style={{ gap: '10px' }}>
                                                        <button id={controls?.buttons?.edit.id}
                                                            className={controls?.buttons?.edit.defaultClass}
                                                            style={{ borderRadius: '5px' }}
                                                            disabled={process?.save}
                                                            hidden={viewType === 2}
                                                            title={labels?.save?.[languageObj?.id]}
                                                            type='submit'>
                                                            {process?.save ? (
                                                                <span className={settings?.react?.html?.spinner?.borderSm} role='status' aria-hidden='true'></span>
                                                            ) : (
                                                                <i id={controls?.icons?.edit.id} className={`${controls?.icons?.edit.defaultClass} mr-1`} />
                                                            )} {labels?.save?.[languageObj?.id]}
                                                        </button>

                                                        <button id={controls?.buttons?.detailsAdd?.id}
                                                            className={controls?.buttons?.detailsAdd?.defaultClass}
                                                            style={{ borderRadius: '5px' }}
                                                            disabled={process?.add}
                                                            hidden={viewType === 2}
                                                            onClick={(e) => getPaymentInformationDetailAdd({ e: e, subMethod: controls?.buttons?.detailsAdd?.id, })}
                                                            title={labels?.addDetail?.[languageObj?.id]}
                                                            type='button'>
                                                            {process?.add ? (
                                                                <span className={settings?.react?.html?.spinner?.borderSm} role='status' aria-hidden='true'></span>
                                                            ) : (
                                                                <i id={controls?.icons?.detailsAdd?.id} className={`${controls?.icons?.detailsAdd?.defaultClass} mr-1`} />
                                                            )} {labels?.addDetail?.[languageObj?.id]}
                                                        </button>

                                                        <button id={controls?.buttons?.back?.id}
                                                            className={controls?.buttons?.back?.defaultClass}
                                                            style={{ borderRadius: '5px' }}
                                                            disabled={process?.back}
                                                            onClick={(e) => goToBack({ e: e, subMethod: controls?.buttons?.back?.id, })}
                                                            title={labels?.back?.[languageObj?.id]}
                                                            type='button'>
                                                            {process?.back ? (
                                                                <span className={settings?.react?.html?.spinner?.borderSm} role='status' aria-hidden='true'></span>
                                                            ) : (
                                                                <i id={controls?.icons?.back?.id} className={`${controls?.icons?.back?.defaultClass} mr-1`} />
                                                            )} {labels?.back?.[languageObj?.id]}
                                                        </button>
                                                    </div>
                                                </form>
                                                <hr className='my-4 opacity-50' />

                                                {/* Section: Details */}
                                                <div className='d-flex align-items-center mt-4 mb-2'>
                                                    <div className='bg-light p-1 rounded-circle mr-2 shadow-sm' style={{ width: '28px', height: '28px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                        <i className={`${icons?.fasFa?.listUl} text-secondary`} style={{ fontSize: '12px' }}></i>
                                                    </div>
                                                    <h6 className='mb-0 font-weight-bold text-dark'>{labels?.details?.[languageObj?.id]}</h6>
                                                </div>
                                                <TableIndex tableId={dtPaymentInformationDetailsId} languageObj={languageObj} />
                                            </div>
                                        </div>

                                    ) : (
                                        <div></div>
                                    )}
                                </div>
                            </div>
                        ) : (
                            <AccessDenied languageObj={languageObj} />
                        )}
                    </div>
                </section>

            </div>

            {modalObj?.showModal && (
                <PaymentInformationDetailAdd
                    modalObj={modalObj}
                    setModalObj={setModalObj} />
            )}
        </div>
    )
}